import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { msg } from 'api';
import { getProductAlternativesLink } from 'apps/products/links';

export default class ShowAlternativesButton extends PureComponent {
  static propTypes = {
    product: PropTypes.object.isRequired,
  };

  render() {
    return (
      <div className="fop-add-oos">
        <Link to={getProductAlternativesLink(this.props.product)} className="fop-alternatives">
          <span>{msg.fop.alternatives.seeAlternativesLabel}</span>
        </Link>
      </div>
    );
  }
}
